import _ from 'underscore';
import angular from 'angular';
import moment from 'moment';

const REPORT_TYPES = [{
  key: 'Daily Reservations Report',
  value: 'ADMISSION_GROUPS_SUMMARY'
}, {
  key: 'Daily Tickets Report',
  value: 'UPCOMING_EVENT_TICKET_SUMMARY'
}];

const TIMESTRING_FORMAT = 'hh:mm A';

function EditScheduledReportModalCtrl($scope, $uibModalInstance, report, venueId, scheduledReportConfigService, sdkUtils, alertService) {

  $scope.isNew = false;
  $scope.daysOfTheWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  $scope.timepickerConfig = {
    minuteStep: 5
  };
  $scope.toggleDay = (day) => {
    const index = _.indexOf($scope.report.reportDaysOfWeek, day);
    if (index === -1) {
      $scope.report.reportDaysOfWeek.push(day);
    } else {
      $scope.report.reportDaysOfWeek.splice(index, 1);
    }
  };

  $scope.reportTypes = REPORT_TYPES;

  if (!report) {
    // Creating new report
    $scope.isNew = true;
    $scope.report = {};
    $scope.report.time = '11:30 PM';
    $scope.report.name = null;
    $scope.report.reportDaysOfWeek = [];
    $scope.report.type = $scope.reportTypes[0].value;
  } else {
    // Editing existing report
    report.time = timeStringFromScheduledReportConfig(report);
    report.reportDaysOfWeek = (report.reportDaysOfWeek && report.reportDaysOfWeek.length) ? report.reportDaysOfWeek : _.range(7);
    $scope.report = angular.copy(report);
  }

  $scope.close = function (resp) {
    $uibModalInstance.close(resp || false);
  };

  $scope.save = function _save() {
    $scope.submitted = true;

    if (!$scope.form.$valid) return null;

    $scope.saving = true;

    const reportTime = reportTimeFromTimeString($scope.report.time);

    if (!reportTime) return alertService.error('Please choose a valid time');

    const {
      reportTimeHour,
      reportTimeMinute
    } = reportTime;

    const options = {
      reportTimeHour,
      reportTimeMinute,
      name: $scope.report.name,
      reportDaysOfWeek: $scope.report.reportDaysOfWeek,
      reportType: $scope.report.type
    };

    if (!$scope.isNew) {
      if (!$scope.report._id) {
        return _error();
      }

      return scheduledReportConfigService.updateById($scope.report._id, options)
        .then(response => {
          $scope.saving = false;
          $scope.form.$setPristine();
          $scope.close(response);
        })
        .catch(_error);
    }

    if (!venueId) {
      return _error();
    }

    return scheduledReportConfigService.createByVenueId(venueId, options)
      .then(response => {
        $scope.saving = false;
        $scope.form.$setPristine();
        $scope.close(response);
      })
      .catch(_error);
  };

  function _error(resp) {
    const msg = sdkUtils.getErrorFromResponse(resp);

    alertService.error(msg);

    $scope.loading = false;
  }

  function timeStringFromScheduledReportConfig(config) {
    config = config || {};
    const reportTimeHour = config.reportTimeHour || 11;
    const reportTimeMinute = config.reportTimeMinute || 30;
    return moment.utc().hours(reportTimeHour).minutes(reportTimeMinute).format(TIMESTRING_FORMAT);
  }

  function reportTimeFromTimeString(timeString) {
    if (!timeString) return null;
    const reportTimeMoment = moment.utc(timeString, TIMESTRING_FORMAT);

    if (reportTimeMoment.isValid()) {
      return {
        reportTimeHour: reportTimeMoment.hours(),
        reportTimeMinute: reportTimeMoment.minutes()
      };
    }

    return null;
  }
}

EditScheduledReportModalCtrl.$inject = [
  '$scope',
  '$uibModalInstance',
  'report',
  'venueId',
  'jsSdk.scheduledReportConfig',
  'jsSdk.utils',
  'alertService'
];

export default EditScheduledReportModalCtrl;



// WEBPACK FOOTER //
// ./src/modals/editScheduledReport/controller.js